import { render, staticRenderFns } from "./ProjectsItemCalendarComponent.vue?vue&type=template&id=a57da230&"
import script from "./ProjectsItemCalendarComponent.vue?vue&type=script&lang=js&"
export * from "./ProjectsItemCalendarComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsItemCalendarComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCardTitle,VDialog,VIcon,VSelect,VSheet})
